if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"OP-WRAPPER","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(38[58]8|(174|915|981)7|2164|4976|8096)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}